// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: var(--color-bg);
  color: var(--color-text);
  font-family: var(--font-sans);
  border-right: 1px solid var(--color-border);
  transition: width var(--duration-slow) var(--easing-standard), background-color var(--duration-base) var(--easing-standard), border-color var(--duration-base) var(--easing-standard);
  z-index: var(--z-sidebar);
  overflow: visible !important;
}
.sidebar.resizing {
  transition: none;
}
.sidebar.expanded {
  width: var(--sidebar-width);
}
.sidebar.expanded .menu-title {
  opacity: 1;
  max-width: none;
  display: block;
}
.sidebar.expanded .dashboard-title {
  opacity: 1;
  display: block;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sidebar.collapsed {
  width: var(--sidebar-width-collapsed);
}
.sidebar.collapsed .menu-title {
  opacity: 0;
  max-width: 0;
  display: none;
}
.sidebar.collapsed .sidebar-toggler .rotate-180 {
  transform: rotate(180deg);
}
.sidebar.collapsed .dashboard-title {
  opacity: 0;
  display: none;
}
.sidebar .sidebar-header {
  display: flex;
  position: relative;
  padding: var(--sp-4) var(--sp-4);
  height: var(--topbar-height);
  flex-shrink: 0;
  align-items: center;
  justify-content: flex-end;
  background-color: var(--color-bg);
}
.sidebar .sidebar-header::after {
  content: "";
  position: absolute;
  left: var(--sp-4);
  right: var(--sp-4);
  bottom: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, rgba(14, 165, 233, 0.55) 35%, rgba(139, 92, 246, 0.55) 70%, transparent 100%);
}
.sidebar .sidebar-header .header-content {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}
.sidebar .sidebar-header .dashboard-title {
  font-size: 20px;
  font-weight: var(--fw-bold);
  letter-spacing: -0.01em;
  margin-left: var(--sp-3);
  padding-left: var(--sp-5);
  white-space: nowrap;
  transition: opacity var(--duration-slow) var(--easing-standard);
  background: linear-gradient(135deg, #0284C7 0%, #7C3AED 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}
.sidebar .toggler {
  height: 35px;
  width: 35px;
  color: var(--color-text-muted);
  border: 1px solid var(--color-border);
  background: var(--color-bg);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-md);
  transition: background var(--duration-base) var(--easing-standard), color var(--duration-base) var(--easing-standard), border-color var(--duration-base) var(--easing-standard);
}
.sidebar .toggler:hover {
  background: var(--color-bg-subtle);
  color: var(--color-text);
  border-color: var(--color-primary);
}
.sidebar .toggler svg {
  font-size: 24px;
  transition: transform var(--duration-slow) var(--easing-standard);
}
.sidebar .menu-title {
  flex: 1 1;
  font-size: 18px;
  font-weight: var(--fw-medium);
  margin-left: var(--sp-3);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: opacity var(--duration-slow) var(--easing-standard);
}
.sidebar .menu-items {
  margin-top: var(--sp-4);
  padding: 0 var(--sp-2);
  flex: 1 1 auto;
  min-height: 0;
  padding-bottom: var(--sp-4);
}
.sidebar.expanded .menu-items {
  overflow-y: auto;
  overflow-x: hidden;
}
.sidebar.collapsed .menu-items {
  overflow: visible;
}
.sidebar .sidebar-resizer {
  position: absolute;
  top: 0;
  right: -3px;
  width: 6px;
  height: 100%;
  cursor: col-resize;
  z-index: calc(var(--z-sidebar) + 1);
  background: transparent;
  transition: background var(--duration-base) var(--easing-standard);
}
.sidebar .sidebar-resizer:hover, .sidebar .sidebar-resizer:focus-visible {
  background: var(--color-primary);
  outline: none;
}
.sidebar.resizing .sidebar-resizer {
  background: var(--color-primary);
}
.sidebar .menu-footer {
  flex-shrink: 0;
  padding: var(--sp-2) var(--sp-2) var(--sp-3);
  border-top: 1px solid var(--color-border);
}
.sidebar .menu-item {
  height: 44px;
  display: flex;
  align-items: center;
  padding: 0 var(--sp-3);
  cursor: pointer;
  border-radius: var(--radius-md);
  margin: 4px 0;
  color: var(--color-text-muted);
  position: relative;
  overflow: hidden;
  transition: background var(--duration-base) var(--easing-standard), color var(--duration-base) var(--easing-standard);
}
.sidebar .menu-item:hover {
  background-color: var(--color-bg-subtle);
  color: var(--color-text);
}
.sidebar .menu-item:hover .menu-icon {
  color: var(--color-text);
}
.sidebar .menu-item:hover .menu-title {
  color: var(--color-text);
}
.sidebar .menu-item.active {
  background: linear-gradient(90deg, rgba(14, 165, 233, 0.1) 0%, rgba(139, 92, 246, 0.1) 100%);
  color: var(--color-primary);
  box-shadow: 0 0 0 1px rgba(14, 165, 233, 0.18) inset, 0 6px 18px -8px rgba(14, 165, 233, 0.35);
}
.sidebar .menu-item.active::before {
  content: "";
  position: absolute;
  left: 0;
  top: 8px;
  bottom: 8px;
  width: 3px;
  border-radius: var(--radius-pill);
  background: linear-gradient(180deg, #0284C7 0%, #7C3AED 100%);
  box-shadow: 0 0 10px rgba(14, 165, 233, 0.4);
}
.sidebar .menu-item.active .menu-icon {
  color: var(--color-primary);
  filter: drop-shadow(0 0 4px rgba(14, 165, 233, 0.35));
}
.sidebar .menu-item.active .menu-title {
  color: var(--color-text);
  font-weight: var(--fw-semibold);
}
.sidebar .menu-item.active:hover {
  background: linear-gradient(90deg, rgba(14, 165, 233, 0.16) 0%, rgba(139, 92, 246, 0.16) 100%);
}
.sidebar .menu-item .menu-icon {
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-subtle);
  transition: color var(--duration-base) var(--easing-standard), filter var(--duration-base) var(--easing-standard);
}
.sidebar .menu-item .menu-title {
  flex: 1 1;
  font-size: 18px;
  font-weight: var(--fw-medium);
  margin-left: var(--sp-3);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  opacity: 1;
  transition: opacity var(--duration-slow) var(--easing-standard), color var(--duration-base) var(--easing-standard);
}
.sidebar.collapsed .menu-item {
  width: 44px;
  height: 44px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 6px auto;
}
.sidebar.collapsed .menu-item .menu-icon {
  margin: 0;
}
.sidebar.collapsed .menu-item .menu-title {
  display: none;
}
.sidebar .submenu {
  background-color: transparent;
  margin: 0;
  padding-left: var(--sp-6);
  display: none;
}
.sidebar .submenu.visible {
  display: block;
}
.sidebar .submenu .submenu-item {
  padding: 10px var(--sp-3);
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 16px;
  color: var(--color-text-muted);
  border-radius: var(--radius-md);
  margin: 2px 0;
  position: relative;
  transition: background var(--duration-base) var(--easing-standard), color var(--duration-base) var(--easing-standard);
}
.sidebar .submenu .submenu-item:hover {
  background-color: var(--color-bg-subtle);
  color: var(--color-text);
}
.sidebar .submenu .submenu-item:hover .menu-title {
  color: var(--color-text);
}
.sidebar .submenu .submenu-item.active {
  background: linear-gradient(90deg, rgba(14, 165, 233, 0.1) 0%, rgba(139, 92, 246, 0.1) 100%);
  color: var(--color-primary);
}
.sidebar .submenu .submenu-item.active .menu-title {
  color: var(--color-text);
  font-weight: var(--fw-semibold);
}
.sidebar .submenu .submenu-item .menu-title {
  font-size: 16px;
}

.menu-item-wrapper {
  position: relative;
}
.menu-item-wrapper:hover .submenu.floating {
  display: block;
}

.submenu.floating {
  position: absolute;
  left: calc(100% + 6px);
  top: 0;
  background-color: var(--color-bg);
  min-width: 200px;
  box-shadow: var(--shadow-xl);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  display: none;
  z-index: var(--z-dropdown);
  overflow: visible;
  padding: var(--sp-2);
}
.submenu.floating::before {
  content: "";
  position: absolute;
  left: -12px;
  top: -8px;
  width: 14px;
  height: calc(100% + 16px);
}
.submenu.floating .floating-menu-title {
  padding: 10px var(--sp-3);
  font-size: 18px;
  font-weight: var(--fw-semibold);
  color: var(--color-text);
  cursor: pointer;
  display: flex;
  align-items: center;
  border-radius: var(--radius-md);
  border-bottom: 1px solid var(--color-border);
  padding-bottom: var(--sp-3);
  margin-bottom: var(--sp-2);
}
.submenu.floating .floating-menu-title:hover {
  background-color: var(--color-bg-subtle);
}
.submenu.floating .floating-menu-title.active {
  background: linear-gradient(90deg, rgba(14, 165, 233, 0.1) 0%, rgba(139, 92, 246, 0.1) 100%);
  color: var(--color-primary);
}
.submenu.floating .submenu-item {
  padding: 10px var(--sp-3);
  color: var(--color-text-muted);
  cursor: pointer;
  display: flex;
  align-items: center;
  border-radius: var(--radius-md);
  margin: 2px 0;
  font-size: 16px;
  font-weight: var(--fw-regular);
  transition: background var(--duration-base) var(--easing-standard), color var(--duration-base) var(--easing-standard);
}
.submenu.floating .submenu-item .menu-title {
  color: var(--color-text-muted);
  opacity: 1;
  max-width: none;
  display: block;
  font-size: 16px;
}
.submenu.floating .submenu-item:hover {
  background-color: var(--color-bg-subtle);
}
.submenu.floating .submenu-item:hover .menu-title {
  color: var(--color-text);
}
.submenu.floating .submenu-item.active {
  background: linear-gradient(90deg, rgba(14, 165, 233, 0.1) 0%, rgba(139, 92, 246, 0.1) 100%);
}
.submenu.floating .submenu-item.active .menu-title {
  color: var(--color-text);
  font-weight: var(--fw-semibold);
}

.menu-footer .submenu.floating {
  top: auto;
  bottom: 0;
}

.submenu.visible {
  display: block;
}

.summary-menu,
.submenu-item.summary-menu {
  cursor: not-allowed;
  opacity: 0.45;
}
.summary-menu:hover,
.submenu-item.summary-menu:hover {
  background-color: transparent !important;
  cursor: not-allowed;
}
.summary-menu.active,
.submenu-item.summary-menu.active {
  background: linear-gradient(90deg, rgba(14, 165, 233, 0.1) 0%, rgba(139, 92, 246, 0.1) 100%) !important;
  opacity: 1;
}

.main-content {
  transition: margin-left var(--duration-slow) var(--easing-standard), width var(--duration-slow) var(--easing-standard);
}
.main-content.sidebar-expanded {
  margin-left: var(--sidebar-current-width, var(--sidebar-width));
  width: calc(100% - var(--sidebar-current-width, var(--sidebar-width)));
}

body.sidebar-resizing {
  cursor: col-resize;
  -webkit-user-select: none;
          user-select: none;
}
body.sidebar-resizing .main-content {
  transition: none;
}`, "",{"version":3,"sources":["webpack://./src/component/ui/Sidebar/Sidebar.scss"],"names":[],"mappings":"AAQA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EAGA,aAAA;EACA,sBAAA;EAEA,iCAAA;EACA,wBAAA;EACA,6BAAA;EACA,2CAAA;EACA,qLAAA;EAGA,yBAAA;EACA,4BAAA;AAZF;AAeE;EACE,gBAAA;AAbJ;AAgBE;EAGE,2BAAA;AAhBJ;AAkBI;EACE,UAAA;EAIA,eAAA;EACA,cAAA;AAnBN;AAsBI;EACE,UAAA;EACA,cAAA;EAEA,YAAA;EACA,gBAAA;EACA,uBAAA;AArBN;AAyBE;EACE,qCAAA;AAvBJ;AAyBI;EACE,UAAA;EACA,YAAA;EACA,aAAA;AAvBN;AA0BI;EACE,yBAAA;AAxBN;AA2BI;EACE,UAAA;EACA,aAAA;AAzBN;AA8BE;EACE,aAAA;EACA,kBAAA;EACA,gCAAA;EACA,4BAAA;EAEA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iCAAA;AA7BJ;AAgCI;EACE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gIAAA;AA9BN;AAuCI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,8BAAA;AArCN;AAwCI;EAEE,eAAA;EACA,2BAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,mBAAA;EACA,+DAAA;EAEA,6DAAA;EACA,6BAAA;EACA,qBAAA;EACA,oCAAA;EACA,kBAAA;AAxCN;AA6CE;EACE,YAAA;EACA,WAAA;EACA,8BAAA;EACA,qCAAA;EACA,2BAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,+KAAA;AA3CJ;AA+CI;EACE,kCAAA;EACA,wBAAA;EACA,kCAAA;AA7CN;AAgDI;EACE,eAAA;EACA,iEAAA;AA9CN;AAkDE;EACE,SAAA;EAEA,eAAA;EACA,6BAAA;EACA,wBAAA;EACA,mBAAA;EACA,gBAAA;EAEA,uBAAA;EACA,+DAAA;AAlDJ;AAsDE;EACE,uBAAA;EACA,sBAAA;EAIA,cAAA;EACA,aAAA;EAEA,2BAAA;AAxDJ;AA8DE;EACE,gBAAA;EACA,kBAAA;AA5DJ;AAiEE;EACE,iBAAA;AA/DJ;AAqEE;EACE,kBAAA;EACA,MAAA;EAGA,WAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,mCAAA;EACA,uBAAA;EACA,kEAAA;AArEJ;AAuEI;EAEE,gCAAA;EAEA,aAAA;AAvEN;AA2EE;EACE,gCAAA;AAzEJ;AA+EE;EACE,cAAA;EACA,4CAAA;EACA,yCAAA;AA7EJ;AAgFE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,+BAAA;EACA,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,qHAAA;AA9EJ;AAiFI;EACE,wCAAA;EACA,wBAAA;AA/EN;AAiFM;EAAa,wBAAA;AA9EnB;AA+EM;EAAc,wBAAA;AA5EpB;AAgFI;EACE,4FAAA;EAKA,2BAAA;EACA,8FACE;AAnFR;AAsFM;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,iCAAA;EACA,6DAAA;EACA,4CAAA;AApFR;AAuFM;EACE,2BAAA;EACA,qDAAA;AArFR;AAwFM;EACE,wBAAA;EACA,+BAAA;AAtFR;AAyFM;EACE,8FAAA;AAvFR;AA+FI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,iHAAA;AA7FN;AAiGI;EACE,SAAA;EACA,eAAA;EACA,6BAAA;EACA,wBAAA;EACA,mBAAA;EACA,gBAAA;EAEA,uBAAA;EACA,UAAA;EACA,kHAAA;AAhGN;AAyGI;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAvGN;AAyGM;EAAa,SAAA;AAtGnB;AAuGM;EAAc,aAAA;AApGpB;AAyGE;EACE,6BAAA;EACA,SAAA;EACA,yBAAA;EACA,aAAA;AAvGJ;AAyGI;EACE,cAAA;AAvGN;AA0GI;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,8BAAA;EACA,+BAAA;EACA,aAAA;EACA,kBAAA;EACA,qHAAA;AAxGN;AA2GM;EACE,wCAAA;EACA,wBAAA;AAzGR;AA2GQ;EAAc,wBAAA;AAxGtB;AA2GM;EACE,4FAAA;EAKA,2BAAA;AA7GR;AA+GQ;EACE,wBAAA;EACA,+BAAA;AA7GV;AAiHM;EACE,eAAA;AA/GR;;AAsHA;EACE,kBAAA;AAnHF;AAqHE;EACE,cAAA;AAnHJ;;AAuHA;EACE,kBAAA;EACA,sBAAA;EACA,MAAA;EACA,iCAAA;EACA,gBAAA;EACA,4BAAA;EACA,qCAAA;EACA,+BAAA;EACA,aAAA;EACA,0BAAA;EAGA,iBAAA;EACA,oBAAA;AAtHF;AA4HE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;AA1HJ;AA6HE;EACE,yBAAA;EACA,eAAA;EACA,+BAAA;EACA,wBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,+BAAA;EACA,4CAAA;EACA,2BAAA;EACA,0BAAA;AA3HJ;AA6HI;EACE,wCAAA;AA3HN;AA8HI;EACE,4FAAA;EAKA,2BAAA;AAhIN;AAoIE;EACE,yBAAA;EACA,8BAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,+BAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;EACA,qHAAA;AAlIJ;AAqII;EACE,8BAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAnIN;AAsII;EACE,wCAAA;AApIN;AAsIM;EAAc,wBAAA;AAnIpB;AAsII;EACE,4FAAA;AApIN;AA0IM;EACE,wBAAA;EACA,+BAAA;AAxIR;;AAiJA;EACE,SAAA;EACA,SAAA;AA9IF;;AAkJA;EAAmB,cAAA;AA9InB;;AAiJA;;EAEE,mBAAA;EACA,aAAA;AA9IF;AAgJE;;EACE,wCAAA;EACA,mBAAA;AA7IJ;AAgJE;;EACE,uGAAA;EAKA,UAAA;AAjJJ;;AA4JA;EACE,sHAAA;AAzJF;AA4JE;EACE,+DAAA;EACA,sEAAA;AA1JJ;;AAgKA;EACE,kBAAA;EACA,yBAAA;UAAA,iBAAA;AA7JF;AA+JE;EACE,gBAAA;AA7JJ","sourcesContent":["// Sidebar — Phase 1b. Font sizes restored to the original spec (per user feedback);\n// new hover/active treatment retained and intensified (gradient + glow + accent bar).\n//\n// 구조는 헤더 / 가운데 .menu-items / 맨 아래 고정되는 .menu-footer 세 층입니다.\n// .sidebar 자체가 세로 플렉스이며, 가운데 목록만 남는 높이를 채웁니다. 스크롤은\n// 펼친 상태에서만 걸립니다. 접힌 상태는 떠 있는 하위 메뉴가 잘리지 않도록\n// overflow 를 visible 로 둡니다.\n\n.sidebar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  // 헤더는 고정하고 메뉴 목록만 남는 높이를 채우도록 세로 플렉스로 둡니다.\n  // 이 선언이 없으면 .menu-items 가 100vh 를 넘겨 아래쪽 항목이 잘립니다.\n  display: flex;\n  flex-direction: column;\n  // Tokenized — light mode = #FFFFFF, dark mode = slate-900 (see global.scss).\n  background-color: var(--color-bg);\n  color: var(--color-text);\n  font-family: var(--font-sans);\n  border-right: 1px solid var(--color-border);\n  transition: width var(--duration-slow) var(--easing-standard),\n              background-color var(--duration-base) var(--easing-standard),\n              border-color var(--duration-base) var(--easing-standard);\n  z-index: var(--z-sidebar);\n  overflow: visible !important;\n\n  // 드래그 중에는 폭 전환 애니메이션이 마우스를 따라오지 못해 끊겨 보입니다.\n  &.resizing {\n    transition: none;\n  }\n\n  &.expanded {\n    // 실제 폭은 Sidebar.js 가 인라인으로 지정합니다. 이 값은 조절 기능이\n    // 동작하기 전(첫 페인트)의 기본값 역할만 합니다.\n    width: var(--sidebar-width);\n\n    .menu-title {\n      opacity: 1;\n      // 예전에는 200px 로 묶여 있었습니다. 사이드바를 넓혀도 라벨이 그 이상\n      // 늘지 않아 폭 조절이 무의미해지므로 풀었습니다. 실제 폭은 flex: 1 과\n      // overflow: hidden 이 정합니다.\n      max-width: none;\n      display: block;\n    }\n\n    .dashboard-title {\n      opacity: 1;\n      display: block;\n      // 최소 폭(200px)에서 \"Dashboard\" 가 토글 버튼을 밀어내지 않도록 합니다.\n      min-width: 0;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n\n  &.collapsed {\n    width: var(--sidebar-width-collapsed);\n\n    .menu-title {\n      opacity: 0;\n      max-width: 0;\n      display: none;\n    }\n\n    .sidebar-toggler .rotate-180 {\n      transform: rotate(180deg);\n    }\n\n    .dashboard-title {\n      opacity: 0;\n      display: none;\n    }\n  }\n\n  // ---------- Header (tokenized — flips with theme alongside the body) ----------\n  .sidebar-header {\n    display: flex;\n    position: relative;\n    padding: var(--sp-4) var(--sp-4);\n    height: var(--topbar-height);\n    // 목록이 길어져도 헤더는 줄어들지 않아야 합니다.\n    flex-shrink: 0;\n    align-items: center;\n    justify-content: flex-end;\n    background-color: var(--color-bg);\n\n    // Gradient accent line at the bottom edge (tuned slightly more saturated for white bg).\n    &::after {\n      content: '';\n      position: absolute;\n      left: var(--sp-4);\n      right: var(--sp-4);\n      bottom: 0;\n      height: 1px;\n      background: linear-gradient(\n        90deg,\n        transparent 0%,\n        rgba(14, 165, 233, 0.55) 35%,\n        rgba(139, 92, 246, 0.55) 70%,\n        transparent 100%\n      );\n    }\n\n    .header-content {\n      display: flex;\n      align-items: center;\n      width: 100%;\n      justify-content: space-between;\n    }\n\n    .dashboard-title {\n      // Darker brand gradient so the title reads well on the now-white header.\n      font-size: 20px;\n      font-weight: var(--fw-bold);\n      letter-spacing: -0.01em;\n      margin-left: var(--sp-3);\n      padding-left: var(--sp-5);\n      white-space: nowrap;\n      transition: opacity var(--duration-slow) var(--easing-standard);\n\n      background: linear-gradient(135deg, #0284C7 0%, #7C3AED 100%);\n      -webkit-background-clip: text;\n      background-clip: text;\n      -webkit-text-fill-color: transparent;\n      color: transparent;\n    }\n  }\n\n  // Toggle button — recolored for the white header.\n  .toggler {\n    height: 35px;\n    width: 35px;\n    color: var(--color-text-muted);\n    border: 1px solid var(--color-border);\n    background: var(--color-bg);\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: var(--radius-md);\n    transition: background var(--duration-base) var(--easing-standard),\n                color var(--duration-base) var(--easing-standard),\n                border-color var(--duration-base) var(--easing-standard);\n\n    &:hover {\n      background: var(--color-bg-subtle);\n      color: var(--color-text);\n      border-color: var(--color-primary);\n    }\n\n    svg {\n      font-size: 24px;\n      transition: transform var(--duration-slow) var(--easing-standard);\n    }\n  }\n\n  .menu-title {\n    flex: 1;\n    // Restored to 18px per user feedback.\n    font-size: 18px;\n    font-weight: var(--fw-medium);\n    margin-left: var(--sp-3);\n    white-space: nowrap;\n    overflow: hidden;\n    // 폭을 줄였을 때 글자가 그냥 잘리지 않고 말줄임으로 끝나게 합니다.\n    text-overflow: ellipsis;\n    transition: opacity var(--duration-slow) var(--easing-standard);\n  }\n\n  // ---------- Menu items ----------\n  .menu-items {\n    margin-top: var(--sp-4);\n    padding: 0 var(--sp-2);\n    // 남는 높이를 채우고, 넘치면 이 안에서만 스크롤합니다. flex 자식의 기본값인\n    // min-height:auto 를 0 으로 낮추지 않으면 콘텐츠 높이만큼 늘어나서 스크롤이\n    // 생기지 않습니다.\n    flex: 1 1 auto;\n    min-height: 0;\n    // 아래 여백이 없으면 마지막 항목이 창 밑변에 붙습니다.\n    padding-bottom: var(--sp-4);\n  }\n\n  // 펼친 상태에서만 스크롤을 겁니다. 접힌 상태의 하위 메뉴는 사이드바 바깥으로\n  // 떠서 나오는데(.submenu.floating), overflow-y 를 주면 overflow-x 가 visible\n  // 로 남지 못해 그 패널이 가로로 잘려 버립니다.\n  &.expanded .menu-items {\n    overflow-y: auto;\n    overflow-x: hidden;\n  }\n\n  // 접힌 상태는 아이콘만 남아 훨씬 짧으므로 넘칠 일이 거의 없습니다. 떠 있는\n  // 하위 메뉴가 잘리지 않도록 넘침을 그대로 둡니다.\n  &.collapsed .menu-items {\n    overflow: visible;\n  }\n\n  // ---------- 폭 조절 손잡이 ----------\n  // 오른쪽 경계에 겹쳐 두는 얇은 띠입니다. 평소에는 보이지 않다가 마우스를\n  // 올리거나 드래그 중일 때만 강조선이 나타납니다.\n  .sidebar-resizer {\n    position: absolute;\n    top: 0;\n    // 경계선 위에 걸치도록 절반을 밖으로 내밉니다. 손잡이가 너무 얇으면\n    // 잡기 어려워 실제 판정 폭은 6px 로 둡니다.\n    right: -3px;\n    width: 6px;\n    height: 100%;\n    cursor: col-resize;\n    z-index: calc(var(--z-sidebar) + 1);\n    background: transparent;\n    transition: background var(--duration-base) var(--easing-standard);\n\n    &:hover,\n    &:focus-visible {\n      background: var(--color-primary);\n      // 기본 포커스 링은 6px 띠에서 어색하므로 배경색으로 대신합니다.\n      outline: none;\n    }\n  }\n\n  &.resizing .sidebar-resizer {\n    background: var(--color-primary);\n  }\n\n  // ---------- 하단 고정 메뉴 ----------\n  // 스크롤 영역(.menu-items) 바깥에 있어 위 목록이 길어져도 밀려나지 않고\n  // 항상 사이드바 맨 아래에 남습니다.\n  .menu-footer {\n    flex-shrink: 0;\n    padding: var(--sp-2) var(--sp-2) var(--sp-3);\n    border-top: 1px solid var(--color-border);\n  }\n\n  .menu-item {\n    height: 44px;\n    display: flex;\n    align-items: center;\n    padding: 0 var(--sp-3);\n    cursor: pointer;\n    border-radius: var(--radius-md);\n    margin: 4px 0;\n    color: var(--color-text-muted);\n    position: relative;\n    overflow: hidden;\n    transition: background var(--duration-base) var(--easing-standard),\n                color var(--duration-base) var(--easing-standard);\n\n    &:hover {\n      background-color: var(--color-bg-subtle);\n      color: var(--color-text);\n\n      .menu-icon { color: var(--color-text); }\n      .menu-title { color: var(--color-text); }\n    }\n\n    // Active — soft tinted fill + accent bar + sky-tinted glow on a light surface.\n    &.active {\n      background: linear-gradient(\n        90deg,\n        rgba(14, 165, 233, 0.10) 0%,\n        rgba(139, 92, 246, 0.10) 100%\n      );\n      color: var(--color-primary);\n      box-shadow:\n        0 0 0 1px rgba(14, 165, 233, 0.18) inset,\n        0 6px 18px -8px rgba(14, 165, 233, 0.35);\n\n      &::before {\n        content: '';\n        position: absolute;\n        left: 0;\n        top: 8px;\n        bottom: 8px;\n        width: 3px;\n        border-radius: var(--radius-pill);\n        background: linear-gradient(180deg, #0284C7 0%, #7C3AED 100%);\n        box-shadow: 0 0 10px rgba(14, 165, 233, 0.4);\n      }\n\n      .menu-icon {\n        color: var(--color-primary);\n        filter: drop-shadow(0 0 4px rgba(14, 165, 233, 0.35));\n      }\n\n      .menu-title {\n        color: var(--color-text);\n        font-weight: var(--fw-semibold);\n      }\n\n      &:hover {\n        background: linear-gradient(\n          90deg,\n          rgba(14, 165, 233, 0.16) 0%,\n          rgba(139, 92, 246, 0.16) 100%\n        );\n      }\n    }\n\n    .menu-icon {\n      width: 22px;\n      height: 22px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: var(--color-text-subtle);\n      transition: color var(--duration-base) var(--easing-standard),\n                  filter var(--duration-base) var(--easing-standard);\n    }\n\n    .menu-title {\n      flex: 1;\n      font-size: 18px;\n      font-weight: var(--fw-medium);\n      margin-left: var(--sp-3);\n      white-space: nowrap;\n      overflow: hidden;\n      // 폭을 줄였을 때 글자가 그냥 잘리지 않고 말줄임으로 끝나게 합니다.\n      text-overflow: ellipsis;\n      opacity: 1;\n      transition: opacity var(--duration-slow) var(--easing-standard),\n                  color var(--duration-base) var(--easing-standard);\n    }\n  }\n\n  &.collapsed {\n    // .menu-items 의 padding 은 기본 규칙과 같아 중복이었고, 단축 속성이라\n    // 기본 규칙의 padding-bottom 까지 지워 버려서 제거했습니다.\n\n    .menu-item {\n      width: 44px;\n      height: 44px;\n      padding: 0;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin: 6px auto;\n\n      .menu-icon { margin: 0; }\n      .menu-title { display: none; }\n    }\n  }\n\n  // ---------- Inline submenu (expanded mode) ----------\n  .submenu {\n    background-color: transparent;\n    margin: 0;\n    padding-left: var(--sp-6);\n    display: none;\n\n    &.visible {\n      display: block;\n    }\n\n    .submenu-item {\n      padding: 10px var(--sp-3);\n      display: flex;\n      align-items: center;\n      cursor: pointer;\n      font-size: 16px;\n      color: var(--color-text-muted);\n      border-radius: var(--radius-md);\n      margin: 2px 0;\n      position: relative;\n      transition: background var(--duration-base) var(--easing-standard),\n                  color var(--duration-base) var(--easing-standard);\n\n      &:hover {\n        background-color: var(--color-bg-subtle);\n        color: var(--color-text);\n\n        .menu-title { color: var(--color-text); }\n      }\n\n      &.active {\n        background: linear-gradient(\n          90deg,\n          rgba(14, 165, 233, 0.10) 0%,\n          rgba(139, 92, 246, 0.10) 100%\n        );\n        color: var(--color-primary);\n\n        .menu-title {\n          color: var(--color-text);\n          font-weight: var(--fw-semibold);\n        }\n      }\n\n      .menu-title {\n        font-size: 16px;\n      }\n    }\n  }\n}\n\n// ---------- Floating submenu (collapsed mode hover) ----------\n.menu-item-wrapper {\n  position: relative;\n\n  &:hover .submenu.floating {\n    display: block;\n  }\n}\n\n.submenu.floating {\n  position: absolute;\n  left: calc(100% + 6px);\n  top: 0;\n  background-color: var(--color-bg);\n  min-width: 200px;\n  box-shadow: var(--shadow-xl);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n  display: none;\n  z-index: var(--z-dropdown);\n  // overflow:hidden would clip ::before outside the panel; the bridge needs to live\n  // in the 6px gap between .menu-item and this floating panel.\n  overflow: visible;\n  padding: var(--sp-2);\n\n  // Invisible hover-bridge covering the 6px gap to the parent .menu-item, so the\n  // mouse can travel from the collapsed icon to this floating panel without\n  // dropping .menu-item-wrapper:hover. Slightly larger than the gap on all sides\n  // to forgive imperfect mouse paths.\n  &::before {\n    content: '';\n    position: absolute;\n    left: -12px;\n    top: -8px;\n    width: 14px;\n    height: calc(100% + 16px);\n  }\n\n  .floating-menu-title {\n    padding: 10px var(--sp-3);\n    font-size: 18px;\n    font-weight: var(--fw-semibold);\n    color: var(--color-text);\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    border-radius: var(--radius-md);\n    border-bottom: 1px solid var(--color-border);\n    padding-bottom: var(--sp-3);\n    margin-bottom: var(--sp-2);\n\n    &:hover {\n      background-color: var(--color-bg-subtle);\n    }\n\n    &.active {\n      background: linear-gradient(\n        90deg,\n        rgba(14, 165, 233, 0.10) 0%,\n        rgba(139, 92, 246, 0.10) 100%\n      );\n      color: var(--color-primary);\n    }\n  }\n\n  .submenu-item {\n    padding: 10px var(--sp-3);\n    color: var(--color-text-muted);\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    border-radius: var(--radius-md);\n    margin: 2px 0;\n    font-size: 16px;\n    font-weight: var(--fw-regular);\n    transition: background var(--duration-base) var(--easing-standard),\n                color var(--duration-base) var(--easing-standard);\n\n    .menu-title {\n      color: var(--color-text-muted);\n      opacity: 1;\n      max-width: none;\n      display: block;\n      font-size: 16px;\n    }\n\n    &:hover {\n      background-color: var(--color-bg-subtle);\n\n      .menu-title { color: var(--color-text); }\n    }\n\n    &.active {\n      background: linear-gradient(\n        90deg,\n        rgba(14, 165, 233, 0.10) 0%,\n        rgba(139, 92, 246, 0.10) 100%\n      );\n\n      .menu-title {\n        color: var(--color-text);\n        font-weight: var(--fw-semibold);\n      }\n    }\n  }\n}\n\n// 하단 고정 메뉴의 떠 있는 하위 메뉴는 아래가 아니라 위로 열려야 합니다.\n// 기본값인 top:0 이면 항목이 사이드바 맨 아래에 있어 패널이 화면 밖으로\n// 내려가 잘립니다.\n.menu-footer .submenu.floating {\n  top: auto;\n  bottom: 0;\n}\n\n// Default-true submenu visibility (legacy `.visible` class plus default-open behavior)\n.submenu.visible { display: block; }\n\n// \"Summary\" disabled menu (kept disabled UX from previous design)\n.summary-menu,\n.submenu-item.summary-menu {\n  cursor: not-allowed;\n  opacity: 0.45;\n\n  &:hover {\n    background-color: transparent !important;\n    cursor: not-allowed;\n  }\n\n  &.active {\n    background: linear-gradient(\n      90deg,\n      rgba(14, 165, 233, 0.10) 0%,\n      rgba(139, 92, 246, 0.10) 100%\n    ) !important;\n    opacity: 1;\n  }\n}\n\n// Main content offset (preserved from previous layout contract)\n// 실제 값은 Sidebar.js 가 --sidebar-current-width 와 인라인 스타일로 지정합니다.\n// 여기 있는 var() 는 그 전(첫 페인트)의 기본값입니다.\n//\n// .sidebar-expanded 로 한정한 이유가 있습니다. 팝업 창에서는 LayoutContainer 가\n// Sidebar 를 아예 렌더하지 않아 --sidebar-current-width 가 설정되지 않는데,\n// 한정하지 않으면 이 규칙이 폴백 240px 을 먹여 본문이 통째로 밀립니다.\n.main-content {\n  transition: margin-left var(--duration-slow) var(--easing-standard),\n              width var(--duration-slow) var(--easing-standard);\n\n  &.sidebar-expanded {\n    margin-left: var(--sidebar-current-width, var(--sidebar-width));\n    width: calc(100% - var(--sidebar-current-width, var(--sidebar-width)));\n  }\n}\n\n// 드래그 중에는 본문도 마우스를 즉시 따라와야 하고, 텍스트가 선택되면\n// 화면이 파랗게 물듭니다.\nbody.sidebar-resizing {\n  cursor: col-resize;\n  user-select: none;\n\n  .main-content {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
